/** A safe wrapper for fractional indexing to ensure consistent ordering when generating task keys. */
import { generateKeyBetween } from 'fractional-indexing';

/**
 * Een veilige wrapper voor fractional-indexing die altijd garandeert
 * dat a < b voordat generateKeyBetween wordt aangeroepen.
 */
export function safeGenerateKeyBetween(key1, key2) {
  const k1 = key1 || null;
  const k2 = key2 || null;

  if (!k1 && k2) return generateKeyBetween(null, k2);
  if (k1 && !k2) return generateKeyBetween(k1, null);
  if (!k1 && !k2) return generateKeyBetween(null, null);
  if (k1 === k2) return k1;

  return generateKeyInOrder(k1, k2);
}

const generateKeyInOrder = (k1, k2) => {
  if (k1 < k2) return generateKeyBetween(k1, k2);
  return generateKeyBetween(k2, k1);
};

/** @param {string | null | undefined} a @param {string | null | undefined} b */
export const maxOrderKey = (a, b) => {
  if (!a) return b ?? null;
  if (!b) return a;
  return a < b ? b : a;
};
